export const ROOT = '/';

export const LOGIN = `${ROOT}login` as const; // login page
export const INVITE = `${ROOT}invite/:id` as const; // invite page

export const TOURNAMENTS = `${ROOT}tournaments` as const; // tournaments page
export const TOURNAMENT = `${ROOT}tournaments/:id` as const; // tournament page
export const TOURNAMENT_TEAMS = `${TOURNAMENT}/participated-teams` as const; // tournament page
export const TOURNAMENT_RESULTS = `${TOURNAMENT}/results` as const; // tournament page
export const TOURNAMENT_SCHEDULE = `${TOURNAMENT}/schedule` as const; // tournament page
export const TOURNAMENT_KNOCKOUT = `${TOURNAMENT}/knockout` as const; // tournament knockout page
export const TOURNAMENT_MEDIA = `${TOURNAMENT}/media` as const; // tournament media page
export const TOURNAMENTS_LIST = `${ROOT}tournaments/list` as const; // tournaments list page

export const PLAYERS = `${ROOT}players` as const; // players page
export const REFEREES = `${ROOT}referees` as const; // referees page
export const TEAMS = `${ROOT}teams` as const; // players page
export const GAMES = `${ROOT}games` as const; // games page

export const SETTING = `${ROOT}setting` as const; // setting page
export const SETTINGS_ADMINS = `${SETTING}/admins` as const; // admins setting admins page
export const SETTINGS_GROUPS = `${SETTING}/groups` as const; // admins setting groups page
export const SETTINGS_POSITIONS = `${SETTING}/positions` as const; // admins setting positions page
export const SETTINGS_TOUR_TYPES = `${SETTING}/tour-types` as const; // admins setting tour types page
